import { render, staticRenderFns } from "./CreativePrintInText.vue?vue&type=template&id=24253ac8&scoped=true&"
import script from "./CreativePrintInText.vue?vue&type=script&lang=js&"
export * from "./CreativePrintInText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24253ac8",
  null
  
)

export default component.exports